import { STEPS } from "@/data/content";
import { SectionHeading } from "./SectionHeading";

export const Process = () => (
  <section id="process" className="border-t border-white/5 bg-[#0a0a0a] py-24">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Як проходить співпраця"
        title="Повний супровід у 10 кроків"
        subtitle="Від задання вимог до передачі клієнту на українських номерах — кожен етап під моїм особистим контролем."
      />
      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-md border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
        {STEPS.map((s, i) => (
          <div
            key={s.n}
            data-testid={`process-step-${i + 1}`}
            className="group relative bg-[#0f0f0f] p-7 transition-colors hover:bg-[#151515]"
          >
            <span className="font-heading text-4xl font-bold text-[#B12A2A]">
              {s.n}
            </span>
            <h3 className="mt-3 font-heading text-lg font-semibold text-white">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/55">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
